const API_TAG_TYPES = {
  acl: "Acl",
};

export const API_TAGS = {
  acl: (pageUrl: string) => ({
    type: API_TAG_TYPES.acl,
    id: pageUrl,
  }),
};

export const tagTypes = Object.values(API_TAG_TYPES);
